<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.editBook')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->

                <b-modal v-model="confirmModal"  hide-header hide-footer>
                    <p class="my-4 text-center">{{$t('form.book.adjust_stock')}}</p>
                    <div class="text-center">
                    <b-button class="d-inline" variant="primary" inline 
                    @click="adjustBookStock('yes')">Yes</b-button>
                    <b-button class="d-inline" variant="secondary" inline @click="adjustBookStock('no')">No</b-button>
                    </div>
                   
                </b-modal>

                 <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.editBook')}} </div>

                        <div class="text-right">
                            <button class="btn btn-primary" @click="updateBook()"
                                :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                            <button class="btn btn-info" @click="updateBook(true)"
                                :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                        </div>
                    </div>
                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.book.tabBasicInformation')" active>
                                <div class="row">
                                    <div class="col-md-3 col-sm-4">
                                        <div class="form-group">
                                            <label>{{$t('form.book.photo')}}</label>
                                            <vue-dropzone class="m-0 p-0" ref="myVueDropzone" id="dropzone"
                                                :options="dropzoneOptions" @vdropzone-success="profileUploaded"
                                                @vdropzone-processing="isLoading=true" :useCustomSlot="true">
                                                <img width="100%" :src="image" style="cursor:pointer">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="col-md-9 col-sm-8">
                                        <div class="form-group">
                                            <label for="TitleField">{{$t('form.book.title')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="TitleField" class="form-control"
                                                v-model.trim="$v.book.Title.$model"
                                                :class="{ 'is-invalid': $v.book.Title.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Title.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Title.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Title.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="AuthorField">{{$t('form.book.author')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="AuthorField" class="form-control"
                                                v-model.trim="$v.book.Author.$model"
                                                :class="{ 'is-invalid': $v.book.Author.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Author.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Author.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Author.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="PublisherField">{{$t('form.book.publisher')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="PublisherField" class="form-control"
                                                v-model.trim="$v.book.Publisher.$model"
                                                :class="{ 'is-invalid': $v.book.Publisher.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Publisher.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Publisher.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Publisher.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="EditionField">{{$t('form.book.edition')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="EditionField" type="text" v-model="book.Edition"
                                                class="form-control" v-model.trim="$v.book.Edition.$model"
                                                :class="{ 'is-invalid': $v.book.Edition.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Edition.required">
                                                {{$t('form.validation.required')}}</div>

                                            <div class="invalid-feedback" v-if="!$v.book.Edition.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Edition.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="YearField">{{$t('form.book.year')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="YearField" type="text" maxlength="4" class="form-control"
                                                v-model.trim="$v.book.Year.$model"
                                                :class="{ 'is-invalid': $v.book.Year.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.Year.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Year.numeric">
                                                {{$t('form.validation.numbersAllowed')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.book.Year.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.Year.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="ISBNField">{{$t('form.book.ISBN')}}<span
                                                    class="text-danger">*</span></label>
                                            <input v-model="book.ISBN" id="ISBNField" class="form-control"
                                                v-model.trim="$v.book.ISBN.$model"
                                                :class="{ 'is-invalid': $v.book.ISBN.$error }">
                                            <div class="invalid-feedback" v-if="!$v.book.ISBN.required">
                                                {{$t('form.validation.required')}}</div>

                                            <div class="invalid-feedback" v-if="!$v.book.ISBN.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.book.ISBN.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="onStockField">{{$t('form.book.onStock')}}</label>
                                            <input id="onStockField" class="form-control" :value="book.OnStock" readonly>
                                        </div>

                                    </div>
                                </div>
                            </b-tab>


                            <b-tab :title="$t('form.book.tabStock')">
                                <div class="row">
                                    <div class="col-8">

                                        <div class="table-responsive p-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th>{{$t('form.book.orderDate')}}</th>
                                                    <th>{{$t('form.book.amount')}}</th>
                                                    <th>{{$t('form.book.receiveDate')}}</th>
                                                    <th class="text-right" v-if="!readonly">{{$t('form.book.action')}}
                                                    </th>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(row, orderIndex) in orders" v-bind:key="orderIndex">

                                                        <td class="text-left">{{row.OrderDate}}</td>
                                                        <td class="text-left">{{row.Amount}}</td>
                                                        <td class="text-left">{{row.ReceiveDate}}</td>

                                                        <td class="text-right" v-if="!readonly">
                                                            <a role="button"  :disabled="disableEditForm || readonly" class="text-info" style="cursor:pointer;"
                                                                @click="editOrder(row , orderIndex)">
                                                                <i class="fa fa-edit"></i>

                                                            </a>
                                                            <a role="button"  :disabled="disableEditForm || readonly"  class="ml-3" style="color:red; cursor:pointer;"
                                                                @click="confirmStockAdjustment(row, orderIndex)">
                                                                <i class="fa fa-times"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- 
                                        <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                            @paginate="paginate()">
                                        </pagination> -->

                               
                                
                                
                                    </div>
                                    <div class="col-4">
                                        <div class="card">
                                            <div class="card-header">
                                                <div class="orders-header">
                                                <p>
                                                   <b>{{$t('form.book.bookOrders')}}</b>
                                                   <span class="d-block">{{$t('form.book.currentStock')}} {{book.OnStock}}</span>
                                                </p>
                                                
                                                <div>
                                                    <button type="submit" v-if="order.ID"
                                                    :disabled="disableEditForm || readonly"
                                                    class="btn btn-primary float-right"
                                                    @click="updateOrder()">{{$t('button.update')}}</button>

                                                   <button type="submit" v-else
                                                    :disabled="disableEditForm || readonly"
                                                    class="btn btn-primary float-right"
                                                    @click="addOrder()">{{$t('button.save')}}</button>

                                                     <button type="submit"
                                                    :disabled="disableEditForm || readonly"
                                                    class="btn btn-secondary float-right mr-1"
                                                    @click="cancelOrder()">{{$t('button.cancel')}}</button>

                                                </div>
                                                </div>
                                             
                                            </div>
                                            <div class="card-body">

                                                <div class="form-group">
                                                    <label>{{$t('form.book.orderDate')}} <span
                                                            class="text-danger">*</span></label>
                                                        <date-picker 
                                                            :lang="lang"
                                                            class="date-picker" v-model="student.ProgramStart"
                                                            valueType="format"
                                                            :format="dateFormat"
                                                            v-model.trim="$v.order.OrderDate.$model"
                                                            :popup-style="{ top: '100%', left: 0}"
                                                            :class="{ 'is-invalid': $v.order.OrderDate.$error }"
                                                            :append-to-body="false">
                                                        </date-picker>
                                                    <div class="invalid-feedback" v-if="!$v.order.OrderDate.required">
                                                        {{$t('form.validation.required')}}</div>
                                                    <div class="invalid-feedback" v-if="!$v.order.OrderDate.maxLength">
                                                        {{$t('form.validation.maxLength', {num: $v.order.OrderDate.$params.maxLength.max})}}
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <label for="AuthorField">{{$t('form.book.amount')}}<span
                                                            class="text-danger">*</span></label>
                                                    <input type="number" id="AuthorField" class="form-control"
                                                        v-model.trim="$v.order.Amount.$model"
                                                        :class="{ 'is-invalid': $v.order.Amount.$error }">
                                                    <div class="invalid-feedback" v-if="!$v.order.Amount.required">
                                                        {{$t('form.validation.required')}}</div>
                                                    <div class="invalid-feedback" v-if="!$v.order.Amount.maxLength">
                                                        {{$t('form.validation.maxLength', {num: $v.order.Amount.$params.maxLength.max})}}
                                                    </div>
                                                </div>


                                                <div class="form-group">
                                                    <label>{{$t('form.book.receiveDate')}} </label>
                                                        <date-picker
                                                            :lang="lang"
                                                            class="date-picker"
                                                            valueType="format"
                                                            :format="dateFormat"
                                                            v-model.trim="$v.order.ReceiveDate.$model"
                                                            :popup-style="{ top: '100%', left: 0}"
                                                            :append-to-body="false">
                                                        </date-picker>
                                                   
                                                    <div class="invalid-feedback" v-if="!$v.order.ReceiveDate.maxLength">
                                                        {{$t('form.validation.maxLength', {num: $v.order.ReceiveDate.$params.maxLength.max})}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </b-tab>

                            <b-tab :title="$t('form.book.tabAddCourse')">
                                <div class="row">
                                    <div class="col-sm-7 col-md-8">

                                        <div class="table-responsive p-0">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <th>{{$t('form.book.courses')}}</th>
                                                    <th class="text-right" v-if="!readonly">{{$t('form.book.action')}}
                                                    </th>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(course, index) in selectedCourses" v-bind:key="index">
                                                        <td>{{`${course.CourseCode} - ${course.CourseTitle}`}}</td>

                                                        <td class="text-right" v-if="!readonly">
                                                            <a role="button" style="color:red; cursor:pointer;"
                                                                @click="removeCourse(index)">
                                                                <i class="fa fa-times"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-sm-5 col-md-4" v-if="!readonly">
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="search"
                                                :placeholder="$t('form.book.searchCourse')" v-model="courseTitle"
                                                v-on:keyup="searchCourse">
                                            <div class="input-group-append">
                                                <span class="input-group-text" v-on:click="clear()"
                                                    style="color:red;cursor:pointer;">
                                                    <i class="fa fa-times"></i>
                                                </span>
                                            </div>
                                        </div>

                                        <li class="list-group-item searchCourseBackground" @click="addCourse(course)"
                                            v-for="(course,index) in courses" :key="index" style="cursor: pointer">
                                            {{`${course.CourseCode} - ${course.CourseTitle}`}}
                                        </li>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.book.tabAudit')">
                                <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                    :sort-desc="true" :current-page="currentPage" :fields="fields" small hover bordered
                                    responsive>
                                </b-table>

                                <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                    :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                </b-pagination>
                            </b-tab>

                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vue2Dropzone from "vue2-dropzone";

    import {
        required,
        minLength,
        maxLength,
        decimal,
        numeric,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions','dateFormat', 'editFormInterval', 'datetimeFormat'],

        components: {
            vueDropzone: vue2Dropzone,
        },

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',
                confirmModal:false,
                removeOrderID: null,
                removeOrderIndex:null,
                isLoading: false,
                fullPage: true,
                adjustStock:false,
                request_source: '',
                image: '/images/no-image.png',

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,
                watchIndex:0,

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,

                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                dropzoneOptions: {
                    url: "/api/books/cover-image",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    maxFiles: 1
                },

                book: {

                    Title: null,
                    Author: null,
                    Publisher: null,
                    Edition: null,
                    ISBN: null,
                    Year: null,
                    Cover: null,
                    OnStock: null
                },
                perPageOrders: 5,
                order:{
                    ID:null,
                    OrderDate:this.getDate(), 
                    ReceiveDate:null, 
                    Amount:null, 
                    BookID:null
                },
                pagination: {
                    current_page: 1,
                    from: 1,
                    per_page: 10
                },
                orderIndex:0,
                orders:[],
                courseTitle: '',
                courses: [],
                selectedCourses: [],
                audits: []
            };
        },

        validations: {
            order:{
                OrderDate: {
                    required,
                    maxLength: maxLength(255)
                },
                ReceiveDate: {
                    maxLength: maxLength(31)
                },
                Amount: {
                    required,
                    maxLength: maxLength(225)
                },
            },

            book: {
                Title: {
                    required,
                    maxLength: maxLength(255)
                },
                Publisher: {
                    required,
                    maxLength: maxLength(255)
                },
                Author: {
                    required,
                    maxLength: maxLength(255)
                },
                Edition: {
                    required,
                    maxLength: maxLength(225)
                },
                Year: {
                    required,
                    numeric,
                    maxLength: maxLength(4)
                },
                ISBN: {
                    required,
                    maxLength: maxLength(255)
                }
            }
        },

        mounted() {
            if (!this.permissions.viewBooks) {
                this.$router.push("/");
                return;
            }

            if (this.permissions.editBooks) {
                this.checkForEdit();
                let self = this;

                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);

            }

            this.getAuditsPaginate();
            this.getBookByID();
            this.getBookOrders();
        },

        computed: {
            totalAudits() {
                return this.audits.length
            },

            totalOrders() {
                return this.orders.length
            },
            readonly() {
                return !this.permissions.editBooks;
            }
        },

        watch: {
            book: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            selectedCourses: {
                handler(val) {
                    this.watchIndex++; 
          
                    this.closing = false;
                    if(this.watchIndex==1){
                    this.closing = true;}
                },
                deep: true
            }
        },

        methods: {
            getDate(date=null){
                if(date){
                    return  moment(date).format(this.dateFormat);
                }else{
                    return moment().format(this.dateFormat);
                }
                
            },
            confirmStockAdjustment(order, index){
                this.confirmModal = true;
                this.removeOrderID = order.ID;
                this.removeOrderIndex = index;
            },
            adjustBookStock(val='no'){
                this.confirmModal = false;
                this.adjustStock = val === 'yes'? true: false;
                this.removeOrder();
            },
            removeOrder(){
                const data = {adjust_stock: this.adjustStock, order_id:this.removeOrderID};
                axios.post('/api/bookorder/delete', data).then(resp=>{
                    this.showAlert(resp.data.message)
                    this.orders.splice(this.removeOrderIndex, 1);

                    this.adjustStock = false;
                    this.removeOrderID = null;
                    this.removeOrderIndex = null;
                    if(resp.data.stock){
                        this.book.OnStock = resp.data.stock;
                    }
 

                }).catch(error=>{
                    console.log(error);
                })
            },
            editOrder(order , index){
                this.orderIndex = index;
                this.order={
                    OrderDate:order.OrderDate,
                    ReceiveDate:order.ReceiveDate,
                    Amount:order.Amount,
                    BookID:order.BookID,
                    ID:order.ID
                };
            },
            cancelOrder(){
                this.order = {ID:null,OrderDate:this.getDate(), ReceiveDate:null , Amount:null , BookID:null};
            },
            addOrder(){

                this.$v.order.$touch();
                if (this.$v.order.$invalid) {
                   
              let errorMsg = '';
                      if(this.$v.order. OrderDate.$error){
                            errorMsg = 'Order Date';
                      }

                    if(this.$v.order.ReceiveDate.$error){
                            errorMsg = errorMsg ? errorMsg +", Receive Date": "Receive Date";
                      }

                    if(this.$v.order.Amount.$error){
                            errorMsg = errorMsg ? errorMsg +", Amount": "Amount";
                      }


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }

                this.order.BookID = this.book.ID;
                this.isLoading = true;

                axios.post('/api/bookorder', this.order).then(resp=>{
                    let r = resp.data.data;
                    this.orders = [{
                            OrderDate:r.OrderDate?moment(r.OrderDate).format(this.dateFormat):null,
                            ReceiveDate:r.ReceiveDate?moment(r.ReceiveDate).format(this.dateFormat):null,
                            Amount:r.Amount,
                            BookID:r.BookID,
                            ID:r.ID
                        }, ...this.orders];

                        this.pagination.total = this.pagination.total+1;
                        

                        this.book.OnStock = r.OnStock;
                        this.cancelOrder();
                        this.isLoading = false;
                        this.showAlert(resp.data.message);

                }).catch(error=>{
                    console.log(error);
                      this.isLoading = false;
                })

            },

            updateOrder(){
                this.$v.order.$touch();
                if (this.$v.order.$invalid) {

              let errorMsg = '';
                      if(this.$v.order. OrderDate.$error){
                            errorMsg = 'Order Date';
                      }

                    if(this.$v.order.ReceiveDate.$error){
                            errorMsg = errorMsg ? errorMsg +", Receive Date": "Receive Date";
                      }

                    if(this.$v.order.Amount.$error){
                            errorMsg = errorMsg ? errorMsg +", Amount": "Amount";
                      }


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;

                }
                this.isLoading = true;
                axios.put('/api/bookorder/'+this.order.ID, this.order).then(resp=>{
                     this.orders[this.orderIndex] = this.order;
                     this.book.OnStock = resp.data.data;
                     this.cancelOrder();
                    this.isLoading = false;
                    this.closeAlert();

                }).catch(error=>{
                  this.isLoading = false;
                    console.log(error);
                })
            },





            paginate() {
                this.getBookOrders();
            },
            
            getBookOrders() {

                axios
                    .get(`/api/bookorder?ID=${this.$route.params.id}&page=` + this.pagination.current_page)
                    .then(response => {
                        this.isLoading = false;
                         response.data.data.data.map(r => {
                           this.orders.push({
                                OrderDate:r.OrderDate?moment(r.OrderDate).format(this.dateFormat):null,
                                ReceiveDate:r.ReceiveDate?moment(r.ReceiveDate).format(this.dateFormat):null,
                                Amount:r.Amount,
                                BookID:r.BookID,
                                ID:r.ID,
                            });
                        });
                        this.pagination = response.data.pagination;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        // console.log(error.response);
                    });
            },

            getAuditsPaginate() {
                axios.get('/api/audits-paginate').then(({
                    data
                }) => this.perPageAudits = data);
            },

            profileUploaded(file, response) {
                this.isLoading = false;
                this.book.Cover = response.filename;
            },

            searchCourse() {

                if (this.courseTitle == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');
                    console.clear();

                this.request_source = source;

                axios
                    .get(`/api/courses?codeOrTitle=${this.courseTitle}`, {
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.courses = response.data.data.data;
                    })
                    .catch(error => console.log(error.message));
            },

            addCourse(course) {
                // check if course already assigned or not
                let found = this.selectedCourses.find(c => c.ID == course.ID);

                if (found) {
                    alert('Course already assigned, try different one.');
                    return;
                }

                this.selectedCourses.push({
                    ID: course.ID,
                    CourseTitle: course.CourseTitle,
                    CourseCode: course.CourseCode,
                });

                this.clear();
            },

            removeCourse(index) {
                if (confirm(this.$t('form.validation.delete')) === true) {
                    this.selectedCourses.splice(index, 1);
                }
            },

            clear() {
                this.courseTitle = '';
                this.courses = [];
            },

            updateBook(shouldClose = false) {
                this.$v.book.$touch();

                if (this.disableEditForm) return;

                if (this.$v.book.$invalid) {
                    let errorMsg = '';
                      if(this.$v.book.Title.$error){
                            errorMsg = 'Title';
                      }

                    if(this.$v.book.Author.$error){
                            errorMsg = errorMsg ? errorMsg +", Author": "Author";
                      }

                    if(this.$v.book.Publisher.$error){
                            errorMsg = errorMsg ? errorMsg +", Publisher": "Publisher";
                      }

                    if(this.$v.book.Edition.$error){
                            errorMsg = errorMsg ? errorMsg +", Edition": "Edition";
                      }

                    if(this.$v.book.Year.$error){
                            errorMsg = errorMsg ? errorMsg +", Year": "Year";
                      }

                     if(this.$v.book.ISBN.$error){
                            errorMsg = errorMsg ? errorMsg +", ISBN": "ISBN";
                      }

                 


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }

                let courses = [];

                this.selectedCourses.map(course => courses.push(JSON.stringify(course)));

                let data = {
                    book: this.book,
                    courses: courses
                }

                this.isLoading = true;

                axios
                    .put(`/api/books/${this.$route.params.id}`, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.message) {
                            this.showAlert(response.data.message);

                            if (shouldClose) {
                                clearInterval(this.interval);
                                setTimeout(() => this.$router.go(-1), 2000);
                                return;
                            }
                        }
                       
                    })
                    .catch(error => {
                        this.isLoading = false;

                        if (error.response.data)
                            this.showAlert(error.response.data.message, 'danger');
                    });
            },

            getBookByID() {
                this.isLoading = true;

                axios
                    .get(`/api/books/${this.$route.params.id}/edit`)
                    .then(response => {
                        // this.isLoading = false;

                        this.book = response.data.books;
                        // this.orders = response.data.orders;
                        if(this.book.Cover !== "null" && this.book.Cover !== null){
                            this.getCoverImage();
                        }

                        let vm = this;
                        let obj = null;

                        this.selectedCourses = response.data.course;
                        this.audits = response.data.audits;
                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });
                
                        

                        this.isLoading = false;
                        this.closing = true;
                        
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getCoverImage(){
                this.getImage(`/api/books/${this.$route.params.id}/cover-image`);
            },

            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getBookByID();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },


            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },
            closeAlert() {
                this.alertMessage = '';
                this.alertClass = '';
                this.alert = false;
            },

            // get book cover image
            getImage(url) {
                axios
                    .get(url, {
                        responseType: 'arraybuffer'
                    })
                    .then(response => {
                        this.image = this.imageEncode(response);
                    })
            },

            // encode image to base64
            imageEncode(response) {
                let arrayBuffer = response.data;
                let b64encoded = btoa([].reduce.call(new Uint8Array(arrayBuffer), (p, c) => p + String.fromCharCode(c),
                    ''))
                let mimetype = response.headers['content-type'].toLowerCase()

                return `data:${mimetype};base64,${b64encoded}`
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    };

</script>

<style scoped>
    .searchCourseBackground:hover {
        background: #eee;
    }
    .orders-header{
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        width: 100% !important;
    }
    .orders-header > * ::before, .orders-header > * ::after {
       margin:0 !important;
    }
     .book_submission .v-select ul.vs__dropdown-menu {
        position: relative !important;
    }
</style>
